import { LayoutGrid } from "lucide-react";

import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";

import Cartao from "../components/Cartao";
import { MODULOS } from "../lib/formulario";

/** Em quais módulos a forma aparece e, se quiser, com outro nome em cada um. */
export default function SecaoModulos({ d }) {
  const { form, definirSub } = d;
  return (
    <Cartao titulo="Onde aparece" icone={LayoutGrid} e2e="secao-modulos"
      subtitulo="Ligue os módulos em que o atendente ou o cliente pode escolher esta forma. O nome por módulo é opcional.">
      <ul className="divide-y rounded-xl border">
        {MODULOS.map((m) => {
          const ligado = form.visivel[m.key];
          return (
            <li key={m.key} className="p-3 flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
              <label className="flex items-center gap-3 flex-1 min-w-0 cursor-pointer">
                <Switch checked={ligado} onCheckedChange={(v) => definirSub("visivel", m.key, v)} data-e2e={`modulo-${m.key}`} />
                <span className={`w-8 h-8 rounded-lg flex items-center justify-center shrink-0 transition-colors ${ligado ? "bg-primary/10 text-primary" : "bg-muted text-muted-foreground"}`}>
                  <m.Icone className="w-4 h-4" />
                </span>
                <span className="min-w-0">
                  <span className="text-sm font-medium block">{m.label}</span>
                  <span className="text-[11px] text-muted-foreground block">{m.ajuda}</span>
                </span>
              </label>
              <Input value={form.nomes[m.key] || ""} onChange={(e) => definirSub("nomes", m.key, e.target.value)} disabled={!ligado}
                placeholder={`Nome aqui: ${form.name || "igual ao nome"}`} className="sm:w-60 h-9 text-sm" />
            </li>
          );
        })}
      </ul>
    </Cartao>
  );
}
